export default "__VITE_ASSET__DMnQBw5u__"